import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'absolute',
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0),
  },
}));


EmptyLayout.propTypes = {
  children: PropTypes.node,
};

export default function EmptyLayout({ children }) {
  return (
    <>
      <HeaderStyle/>
      
      {children}
    </>
  );
}
